<template>
  <div id="join_module">
    <div>
      <img src="../../../../static/img/join/joinus.jpg" width="100%" alt="">
    </div>
    <div>
      <div class="welfare_address">
        <!-- 简介与福利待遇 -->
        <el-row :gutter='5'>
          <el-col :span="12">
            <div class="welfare_address_left">
              <div class="left_cup">
                <div class="job_title">工作待遇</div>
                <div class="job_treat_cup">
                  <el-row :gutter="10">
                    <el-col :span="autoSpan(item)" v-for="(item,index) in wealfare.treatment" :key="index">
                      <div class="job_treat">{{item}}</div>
                    </el-col>
                  </el-row>
                </div>
                <div>
                  <div class="job_text">
                    <span>工作时间：</span>
                    <span>{{wealfare.needContent.workTime}}</span>
                  </div>
                  <div class="job_text">人事招聘邮箱：{{wealfare.needContent.mail}}</div>
                  <div class="job_text">联系电话：{{wealfare.needContent.phone}}</div>
                  <div class="job_text">联系人：{{wealfare.needContent.charger}}</div>
                </div>
                <p class="join_text">{{wealfare.summary}}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <b-map></b-map>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="join_jobs">
      <div>
        <el-divider></el-divider>
      </div>
      <el-card class="job_cup" v-for="(job,index) in jobList" :key="index" v-show="job.isShow">
        <div>
          <div style="overflow:hidden;">
            <div class="el-icon-close close" @click="closeJob(job)"></div>
          </div>
          <div v-html="job.content"></div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { jobList } from '@/api/enFrontApi/join';
import bMap from './bMap';
export default {
  data() {
    return {
      wealfare: {
        summary:
          '国家农机装备创新中心由中国一拖集团、洛阳中科龙网、中联重机、清华高端装备研究院洛阳基地、洛阳中科信息产业研究院等组成产学研用团队。成立了以赵春江，陈学庚，雒建斌，李国杰四位院士领衔的技术专家委员会；集聚了中科院、清华大学、中国农业大学、等国内一流院所及学校的高端人才及团队，通过农业互联网平台、大数据技术、共享经济与农业装备的结合，打造“互联网+共享+农业装备”的创新体系，构建智能产品、智能制造、智能服务三大平台，重新定义农业及农业装备，推进精准农业、智慧农业发展。为推进争创国家制造业创新中心的进程，诚聘英才，需求如下：',
        needContent: {
          phone: '0379-60199639',
          mail: ' yy8641@dingtalk.com',
          charger: '杨老师',
          workTime: '9:00-17:30'
        },
        treatment: [
          '底薪+绩效',
          '餐补',
          '交通补贴',
          '五险一金',
          '过节福利',
          '双休'
        ]
      },
      jobList: []
    };
  },
  components: {
    bMap
  },
  created() {
    this.getJobList();
  },
  methods: {
    autoSpan(param) {
      let finalSpan = 0;
      let caseSpan = param.length;
      switch (caseSpan) {
        case 5:
          finalSpan = 5;
          break;
        case 2:
          finalSpan = 3;
          break;
        default:
          finalSpan = 4;
          break;
      }
      return finalSpan;
    },
    getJobList() {
      jobList({ pageNo: 1, pageSize: 500 }).then(res => {
        console.log('res');
        console.log(res);
        res.data.list.forEach(item => {
          let tempObj = { content: '', isShow: true, jobId: '' };
          tempObj.content = item.jobBody;
          tempObj.jobId = item.jobId;
          this.jobList.push(tempObj);
        });
      });
    },
    closeJob(jobObj) {
      jobObj.isShow = false;
    }
  }
};
</script>
<style lang="stylus" scoped>
#join_module {
  width: 100%;
  min-height: 600px;
}

.welfare_address {
  width: 75%;
  margin: 10px auto 0;
  max-height: 380px;

  .welfare_address_left {
    background-color: #D2EDF8;
    max-height: 380px;
    width: 99%;

    .left_cup {
      padding: 10px 15px;
    }
  }
}

.job_title {
  font-size: 24px;
  height: 45px;
  line-height: 45px;
  font-weight: 800;
}

.job_treat_cup {
  width: 100%;

  ul {
    overflow: hidden;
  }

  .job_treat {
    background-color: #139CAC;
    color: #FFFFFF;
    padding: 6px 8px;
    font-size: 18px;
  }
}

.job_text {
  font-size: 16px;
  height: 25px;
  line-height: 25px;
}

.join_jobs {
  width: 75%;
  margin: 0 auto;

  .job_cup {
    margin-bottom: 15px;

    .job_second_titile {
      font-size: 20px;
      height: 45px;
      line-height: 45px;
      font-weight: 800;
    }

    .close {
      float: right;
      font-size: 24px;
      cursor: pointer;
    }
  }
}

img {
  vertical-align: middle;
}

.join_text {
  text-indent: 2em;
}
</style>



// WEBPACK FOOTER //
// src/pages/enViews/joinus/join.vue